import { render, staticRenderFns } from "./InfoCardComp.vue?vue&type=template&id=0c03b062"
import script from "./InfoCardComp.vue?vue&type=script&lang=js"
export * from "./InfoCardComp.vue?vue&type=script&lang=js"
import style0 from "./InfoCardComp.vue?vue&type=style&index=0&id=0c03b062&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports